import { FormattedDate, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import defaultShield from 'assets/club/shield_none.png';
import { Vertical } from 'atoms/layout/flex';
import { BodyM, BodyS } from 'atoms/typography';
import { Row } from 'components/seo/ui';

const Logo = styled.img`
  width: 100%;
`;

export type Props<T extends string> = {
  stats: T[];
  transfer: {
    id: string;
    team: {
      name: string;
      pictureUrl?: string | null;
      to?: string;
    };
    startDate: Date;
    endDate: Date | null;
    stats: Record<T, number>;
  };
};

export const Transfer = <T extends string>({ transfer, stats }: Props<T>) => {
  return (
    <Row
      style={{
        gridTemplateColumns: `var(--triple-unit) 1fr repeat(${stats.length}, calc(4 * var(--unit)))`,
      }}
    >
      <Logo src={transfer.team.pictureUrl || defaultShield} alt="" />
      <Vertical gap={0}>
        <BodyM as="p">
          {transfer.team.to ? (
            <Link to={transfer.team.to}>{transfer.team.name}</Link>
          ) : (
            transfer.team.name
          )}
        </BodyM>
        <BodyS as="p" color="var(--c-nd-600)">
          <FormattedDate value={transfer.startDate} year="numeric" />
          {' - '}
          {transfer.endDate ? (
            <FormattedDate value={transfer.endDate} year="numeric" />
          ) : (
            <FormattedMessage
              id="Seo.Transfers.Transfer.now"
              defaultMessage="Now"
            />
          )}
        </BodyS>
      </Vertical>
      {stats.map(stat => (
        <BodyM as="p" key={stat}>
          {transfer.stats[stat]}
        </BodyM>
      ))}
    </Row>
  );
};
